import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-modal-erro',
  templateUrl: './modal-erro.component.html',
  styleUrls: ['./modal-erro.component.scss']
})
export class ModalErroComponent implements OnInit {
  @ViewChild('content') modalErro: ElementRef;
  @Input() titulo: any = '';
  @Input() mensagem: any = '';

  constructor(private modalService: NgbModal) { }

  ngOnInit(): void {
  }

  open(){
    this.modalService.open(this.modalErro, { ariaLabelledBy: 'modal-basic-title', centered: true, backdrop:false });
  }
}
